/* eslint-disable @typescript-eslint/no-unsafe-type-assertion */
/* eslint-disable @typescript-eslint/consistent-type-assertions */
type UrlWithScheme<T extends string | null | undefined> = T extends string ? string : T;

/**
 * Adds the scheme to an URL that doesn't have it.
 *
 * Useful for images urls in the HTML head, when the API returns a URL without the scheme.
 *
 * @example
 * addSchemeToUrl('//assets.change.org/images/default-petition-darker.gif') => 'https://assets.change.org/images/default-petition-darker.gif'
 */
export function addSchemeToUrl<T extends string | null | undefined>(url: T): UrlWithScheme<T> {
	if (!url) return url as UrlWithScheme<T>;
	if (url.startsWith('//')) return `https:${url}` as UrlWithScheme<T>;
	return url as UrlWithScheme<T>;
}
